import script from "./AulaView.vue?vue&type=script&setup=true&lang=js"
export * from "./AulaView.vue?vue&type=script&setup=true&lang=js"

import "./AulaView.vue?vue&type=style&index=0&id=2c299e2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c299e2c"]])

export default __exports__